enum SettingKey {
	StartSequenceNumberDossier = "StartSequenceNumberDossier",
	SequenceNumberDossier = "SequenceNumberDossier"
}

export default SettingKey;